import { toJS } from 'mobx';
import { useCountryCode } from 'petdna-lib-uicomponents/hooks';
import { ForProject } from 'petdna-lib-uicomponents/hygraph';
import { useEffect } from 'react';
import { useStores } from 'stores/useStores';

export const useLoadSiteHeader = () => {
  const {
    pagesStore,
    testsStore: { petProfiles, areProfilesLoaded },
    sessionStore: { sessionValid },
  } = useStores();
  const countryCode = useCountryCode(true);

  useEffect(() => {
    if (!countryCode) return undefined;

    const hasPets = (sessionValid && petProfiles) && toJS(petProfiles).length !== 0;
    const forProject: ForProject = hasPets ? ForProject.LIHP : ForProject.LOHP;

    const timeout = setTimeout(() => {
      pagesStore.getSiteHeader(countryCode, forProject);
    }, 1000);

    return () => {
      clearTimeout(timeout);
    };
  }, [areProfilesLoaded, countryCode, pagesStore, petProfiles, sessionValid]);

  return { siteHeader: pagesStore?.siteHeaderData };
};
